import type { CreatorType } from '@shared/api';

export type MessageSeriesPart = {
  key: string;
  text: string;
};

export const normalizeMessageText = (raw?: string | null) => {
  if (!raw) return '';
  return raw
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/\\r/g, '\r')
    .replace(/\\t/g, '\t')
    .replace(/\r\n/g, '\n');
};

export const extractRequestId = (raw?: string | null) => {
  if (!raw) return null;
  const match = raw.match(/request_message_id:\s*(-?\d+)/i);
  if (!match) return null;
  const parsed = Number(match[1]);
  if (!Number.isFinite(parsed)) return null;
  return Math.abs(parsed);
};

export const isAiLikeCreatorType = (creatorType: CreatorType) => {
  return creatorType === 'AI' || creatorType === 'SYSTEM';
};

export const splitMessageSeries = (raw?: string | null) => {
  const normalized = normalizeMessageText(raw);
  if (!normalized) {
    return [{ key: '0-0', text: '' }];
  }

  const parts = normalized.split(/\n{2,}/).filter((part) => part.trim().length > 0);
  const safeParts = parts.length ? parts : [normalized];
  let searchStart = 0;

  return safeParts.map((part) => {
    const matchIndex = normalized.indexOf(part, searchStart);
    const startIndex = matchIndex === -1 ? searchStart : matchIndex;
    searchStart = startIndex + part.length;

    return {
      key: `${startIndex}-${part.length}`,
      text: part,
    };
  });
};
